import styled from "@emotion/styled"
import TodayButton from "app/components/TodayButton"
import Button from "components/Button"
import { buttonsStatesColors } from "theme/Button/constants"

export const StyledRightContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
`

export const StyledLeftContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const StyledTodayButton = styled(TodayButton)`
  color: ${({ theme }) => theme.palette.common.white};
  margin-left: ${({ theme }) => theme.spacing(2)};
  margin-right: -${({ theme }) => theme.spacing()};
  padding-left: ${({ theme }) => theme.spacing(1)};
  padding-right: ${({ theme }) => theme.spacing(1)};
`

export const StyledBackLink = styled(Button)`
  padding: ${({ theme }) => theme.spacing()};
  margin-left: -${({ theme }) => theme.spacing()};
  color: ${({ theme }) => theme.palette.common.white};
  ${buttonsStatesColors.noBackgroundLight};
` as typeof Button
